<template>
    <div class="offtakerCrops shadow">
        <div class="offtakerCrops__img">
            
            <img :src="cropImg" v-if="cropImg" />
            <img v-else :src="`${$baseImageUrl}/banners/auth_bg.jpg`" />
        </div>
        <div class="offtakerCrops__content">

        <div class="offtakerCrops__content__header d-flex justify-content-end">
            <a href="#" @click="likeCrop" class="loading" v-if="!checkLike">
                <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!liking && !gettingOfftakerCrops">
                    <path
                    d="M11.2989 3.57694L12.0059 4.27241L12.7072 3.57113L13.4289 2.84941C14.4868 1.85379 15.8903 1.3081 17.3433 1.32791C18.8007 1.34779 20.1929 1.93509 21.2241 2.96505C22.2554 3.99501 22.8445 5.38646 22.8663 6.84382C22.888 8.29661 22.3441 9.70076 21.35 10.7599L11.9997 20.1214L2.64996 10.7717C1.65597 9.71257 1.11224 8.3085 1.13393 6.85582C1.15568 5.39846 1.74477 4.00701 2.77605 2.97705C3.80733 1.94709 5.19954 1.35979 6.65692 1.33991C8.11117 1.32008 9.51595 1.86678 10.5742 2.86412L11.2989 3.57694Z"
                    stroke="#FFFCF9" stroke-width="2" />
                </svg>
                <Loading :smallSpinner="true" v-if="liking || gettingOfftakerCrops" />
            </a>
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
            <path
                d="M12.0001 2.86402L11.2681 2.14402C10.02 0.963743 8.36091 0.316579 6.64329 0.340007C4.92566 0.363436 3.28484 1.05561 2.0694 2.26949C0.853959 3.48337 0.159674 5.12329 0.134037 6.84089C0.108399 8.55849 0.753429 10.2184 1.9321 11.468L12.0001 21.536L22.0681 11.456C23.2468 10.2064 23.8918 8.54649 23.8662 6.82889C23.8405 5.11129 23.1462 3.47137 21.9308 2.25749C20.7154 1.04361 19.0745 0.351436 17.3569 0.328007C15.6393 0.304579 13.9802 0.951743 12.7321 2.13202L12.0001 2.86402Z"
                fill="#FFFCF9" />
            </svg>

        </div>
        <div class="offtakerCrops__content__bottom">
            <router-link :to="{ name: 'offtaker.mycrop', params: { id: arr[0].crop_id, name: crop }}" class="color__white">
                <h5 class="font-bold font-lg">{{crop}}</h5>
            </router-link>
            <router-link :to="{ name: 'offtaker.mycrop', params: { id: arr[0].crop_id, name: crop }}" class="">
                <div class="listmeta color__white">
                    <span class="listMetaItem">{{sellersCount | formatNumber }} sellers</span>
                    <span class="listMetaseperator color__white">•</span>
                    <span class="listMetaItem">{{ availableQty | formatNumber }} tons</span>
                </div>
            </router-link>
        </div>

        </div>
    </div>
</template>

<script>
export default {
    props: ['crop','arr', 'offtakerCrops', 'gettingOfftakerCrops'],
    data() {
        return {
            // sellers: '',
            // availableQty: '',
            // cropImgs: '',
            liking: false
        }
    },
    computed: {
        cropImg() {
            const arr = []
            if(this.arr && this.arr.length !== 0) {
                this.arr.filter(item => {
                    if(item.crop.image_url) {
                        arr.push(item.crop.image_url)
                    }
                })
                const img = arr.find(item => item !== null)
                return img ? img : ''
            }
            return ''
        },
        availableQty() {
            if(this.arr && this.arr.length !== 0) {
                const total = this.arr.reduce((sum, item) => {
                return sum + (Number(item.kg_yield) - Number(item.kg_sold)) 
                }, 0)
                return Number(total / 1000)
            }
            return ''
        },
        sellersCount() {
            const farmIds = []
            if(this.arr && this.arr.length !== 0) {
                this.arr.filter(item => {
                    if(!farmIds.includes(item.farm_id)) {
                        farmIds.push(item.farm_id)
                    }
                })
            }
            return farmIds.length
        },
        checkLike() {
            if(this.offtakerCrops.length !== 0 && this.arr.length !== 0) {
                const value = this.offtakerCrops.find(item => item.id === this.arr[0].crop_id)
                if(value) {
                    return true
                } else {
                    return false
                }
            } 
            return false
        }
    },
    methods: {
        getCropImgs() {
            this.arr.filter(item => {
                if(item.crop.image_url) {
                    this.cropImgs.push(item.crop.image_url)
                }
            })
        },
        getAvailableQty() {
            const total = this.arr.reduce((sum, item) => {
               return sum + (Number(item.kg_yield) - Number(item.kg_sold)) 
            }, 0)
            this.availableQty = Number(total / 1000)
        },
        countSellers() {
            const farmIds = []
            this.arr.filter(item => {
                if(!farmIds.includes(item.farm_id)) {
                    farmIds.push(item.farm_id)
                }
            })
            this.sellers = farmIds.length
        },
        likeCrop() {
            console.log(this.arr)
            this.liking = true;
            const obj = {
                crops: [this.arr[0].crop_id]
            }
            this.$http.post('off_takers/crops', obj)
            .then((response) => {
                console.log(response.data)
                this.$emit('reGet')
            })
            .catch(error => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.liking = false
            })
        }
    }
}
</script>

<style>

</style>